
"use client";

import BaseModal from "../common/BaseModal";
import DefaultButton from "../buttons/DefaultButton";
import H2Header from "../headers/h2";
import React, {useContext, useState} from "react";
import {ApiContext} from "../contexts/ApiContext";
import {useAuth} from "../../providers/authProvider";


function PresentSelectionModal(
    props: {
        openModal: boolean,
        setOpenModal: (arg: boolean) => void,
        presents: any,
        children?: any,
        setChildren?: any,
        welcomePage: boolean,
        rowData: any,
        admin?: boolean
    }) {
    const {Url } = useContext(ApiContext)
    const { token } = useAuth();
    const [message, setMessage] = useState('')
    let patchUrl: string;
    if (props.admin){
        patchUrl = Url + 'admin/child-present'
    }else{
        patchUrl = Url + 'user/child-present'
    }
    function handlePresentSelection(PresentID: any, PresentName: any){
        if (!props.rowData) return;
        if (props.welcomePage) {
            const newChildren = props.children.map((c: any) => {
                if (c.ID === props.rowData.ID) {
                    let child
                    child = c
                    child.PresentID = PresentID
                    child.PresentName = PresentName

                    return child;
                } else {
                    // The rest haven't changed
                    return c;
                }
            })
            if (props.setChildren) props.setChildren(newChildren)
        }
        else{
            setMessage("Bezig met opslaan...")
            fetch(patchUrl, {
                method: 'PATCH',
                headers: {
                    'content-type': 'application/json',
                    'Authorization': "Bearer " + token,
                },
                body: JSON.stringify({
                    ID: props.rowData.ChildID,
                    PresentID: PresentID
                }),
            }).then((res: any) => {
                if (res.status === 200) {
                    //Saving successfully.
                    setMessage("")
                    props.setOpenModal(false)
                } else {
                    //Saving failed
                    setMessage("Het opslaan is mislukt, neem contact op.")
                }
            })
        }
        props.setOpenModal(false)
    }

    const presents = props.presents && props.presents.length > 0 ? props.presents.map((present: any) =>
        <div className="hover:bg-blue-400 hover:bg-opacity-30"
             onClick={() => handlePresentSelection(present.ID, present.Name)} key={present.ID}>
            <hr/>
            <div className="grid grid-cols-3">
                <div className="col-span-2">
                    <H2Header headerText={present.Name}/>
                    <p>{present.Description}</p>
                    <DefaultButton content="Selecteer dit cadeau"
                                   onClick={() => handlePresentSelection(present.ID, present.Name)}></DefaultButton>
                </div>
                <div className="col-span-1">
                    <img src={present.ImageURL} alt={present.Name} width="200" height="200"/>
                </div>
            </div>
        </div>
    ) : null
    return (
        <BaseModal
            show={props.openModal}
            onClose={() => props.setOpenModal(false)}
            title={`Cadeau voor ${props.rowData?.FirstName}`}
            size="lg"
            footer={
                <DefaultButton onClick={() => props.setOpenModal(false)} content="Annuleren" />
            }
        >
            <p className="text-base leading-relaxed text-gray-500">
                Hieronder kun je selecteren welk cadeautje {props.rowData?.FirstName} wilt ontvangen.
                Selecteer per kind 1 cadeau. Het zou kunnen dat een cadeau niet beschikbaar is, wij zorgen dan voor een passend alternatief.
            </p>
            <p className="text-base leading-relaxed text-red-500">
                {message}
            </p>
            {presents}
        </BaseModal>
    );
}
export default PresentSelectionModal
